export class FormulaVariable {
	identifier: string;
	value: any;
	formula: string;
}